// Cognito UserPoolなどのAWSに関する情報を設定ファイル
const AwsConfig = {
  Region: process.env.VUE_APP_AWS_REGION,
  UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID,
  ClientId: process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID
};

export { AwsConfig };
